<template lang="pug">
.confirm-container(@touchmove.prevent)
  popup(@close="close")
    .confirm-content
      .title(
        :class=`{
          'is-subtitle': !!info.subtitle,
        }`
      )
        CardB(:rob="false", :info="info")
      .description
        p.titles 仅限哈啰APP骑行使用：
        p.content 本卡为哈啰APP专享卡，购卡后仅限在哈啰APP使用
      template(v-if="info")
        .description(v-if="info.businessType === 1")
          p.titles 本卡适用于单车骑行，不适用于助力车骑行：
          p.content 本卡限购卡城市使用，景区及特别特别使用范围区域除外
        .description(v-if="info.businessType === 2")
          p.titles 仅限助力车骑行，不适用单车骑行
          p.content 本卡限哈啰助力车使用，限城市共享、有桩业务，限购卡城市使用，抵扣金额以卡面信息为准
      .description
        p.titles 温馨提示：
        p.content 本卡仅限哈啰APP开锁可用，支付宝扫码骑车仍需按此付费
    .footer
      .btn(@click="onLeft") {{ leftBtn }}
      .btn.actived(@click="onRight") {{ rightBtn }} {{ info.currentPrice }}元
</template>

<script>
import popup from './popup';
import CardB from './card-b';

export default {
  components: {
    popup,
    CardB,
  },
  props: {
    info: {
      type: Object,
      default: null,
    },
    leftBtn: {
      type: String,
      default: '取消',
    },
    rightBtn: {
      type: String,
      default: '立即支付',
    },
    appendToBody: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    if (this.appendToBody) {
      this.$nextTick(() => {
        document.body.appendChild(this.$el);
      });
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    onLeft() {
      this.$emit('onLeft');
    },
    onRight() {
      this.$emit('onRight');
    },
  },
};
</script>

<style lang="less" scoped>
.confirm-container {
  font-size: 16px;

  .confirm-content {
    position: relative;
    padding-top: 0.65rem;
    padding-left: 0.25rem;
    padding-right: 0.27rem;
    padding-bottom: 0.01rem;
    width: 100vw;
    box-sizing: border-box;
    background-color: #f7f9fa;

    .title {
      color: #242729;
      font-size: 0.2rem;
      font-weight: 500;
      padding: 0.02rem 0 0 0;
      text-align: left;
      position: absolute;
      top: -0.55rem;
      left: 0.24rem;

      .card-container {
        padding-top: 0.21rem;
      }
    }

    .is-subtitle {
      top: -0.71rem;

      .card-container {
        padding-top: 0.17rem;
      }
    }

    .description {
      text-align: left;

      .titles {
        font-size: 0.12rem;
        font-weight: 500;
        color: #242729;
        line-height: 0.17rem;
      }

      .content {
        font-size: 0.12rem;
        font-weight: 400;
        color: #879099;
        line-height: 0.17rem;
        margin-top: 0.03rem;
        margin-bottom: 0.23rem;
      }
    }
  }

  .footer {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    margin-top: 0.12rem;
    padding: 0 0.24rem;

    .btn {
      width: 1.58rem;
      height: 0.48rem;
      background: #f0f3f5;
      border-radius: 0.08rem;
      margin-right: 0.12rem;
      font-size: 0.17rem;
      font-weight: 500;
      color: #879099;
      line-height: 0.48rem;

      &.actived {
        width: 1.57rem;
        height: 0.48rem;
        background: #08f;
        border-radius: 0.08rem;
        font-size: 0.17rem;
        font-weight: 500;
        color: #fff;
        line-height: 0.48rem;
      }
    }
  }
}
</style>
